/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { useMemo } from "react";

import { CosmosSearchItem } from "../types";

export interface SearchItemsGroup {
	images: boolean;
	items: CosmosSearchItem[];
}

export const useGroupedItems = (items?: CosmosSearchItem[]): SearchItemsGroup[] => {
	return useMemo(() => {
		const result: SearchItemsGroup[] = [];
		if (!items?.length) return result;

		const withoutImage = items.filter((item) => !item.asset);
		const withImage = items.filter((item) => item.asset);
		const groupSize = 2;

		for (let i = 0; i < withoutImage.length || i < withImage.length; i += groupSize) {
			if (i < withoutImage.length) result.push({ images: false, items: withoutImage.slice(i, i + groupSize) });
			if (i < withImage.length) result.push({ images: true, items: withImage.slice(i, i + groupSize) });
		}

		return result;
	}, [items]);
};
